import { ViewMode } from '@40seas/entities/common';
import { IntentType } from '@40seas/entities/intents';
import jwt_decode from 'jwt-decode';
import { convertStringToEnumValue } from './layoutStrategyManager';
import { DashboardModalConfig, LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';

export class AddContactModalStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply = (): boolean => {
        const { user, isAdmin, appStore } = this.params;

        const isOverviewTenant = [ViewMode.MultipleSupplier, ViewMode.MultipleSupplierAndTenant].includes(appStore.viewMode);

        return !isAdmin && !user?.fullName && !isOverviewTenant;
    };

    openModal = (): DashboardModalConfig => {
        const { urlToken, appStore } = this.params;

        const isSupplier = appStore.viewMode === ViewMode.Supplier;

        const configurationOverrides = isSupplier ? { signatureRightNotMandatory: true } : undefined;
        const modalIntent = isSupplier ? IntentType.SupplierSignatory : IntentType.AddContact;

        if (!urlToken) {
            return { intentType: modalIntent, token: '', configurationOverrides };
        }

        const intent = jwt_decode<{ intentType: string }>(urlToken);
        const intentType = convertStringToEnumValue(intent.intentType) || modalIntent;

        return { intentType, token: urlToken };
    };
}
